import { POST } from "../../APiHelper/API";
let source;
export const searchLeagueRefereeToAddAPICall = (league_id, term, onSuccess, onError) => {
    const data = {
        term: term
    }
    source = POST(`/api/v1/leagues/${league_id}/search_referee_for_add`, data, onSuccess, onError, true, source)
}